import * as React from "react";
function SvgCompleteStep(props) {
  return <svg width={14} height={14} viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}><rect x={0.333984} y={0.333496} width={13.3333} height={13.3333} rx={6.66667} fill="#727491" /></svg>;
}
export default SvgCompleteStep;